import moment from 'moment-timezone';

import { GetRoomInput, RoomWithMetadata } from './interfaces';

export { RoomWithMetadata } from './interfaces';

export const getRoom = (params: GetRoomInput): RoomWithMetadata => {
  const timeAgo = moment(params.conversation.dateCreated).tz(params.timezone).calendar();
  const room: RoomWithMetadata = {
    roomId: params.conversation.sid,
    roomName: timeAgo,
    avatar: '',
    users: params.users ?? [],
    attributes: params.attributes,
    sid: params.conversation.sid,
    uniqueName: params.conversation.uniqueName,
  };

  return room;
};
